export var UspDialogs;
(function (UspDialogs) {
    UspDialogs["AtolProtected"] = "atol-protected";
    UspDialogs["LowestProceGuarantee"] = "lowest-price-guarantee";
    UspDialogs["AbtaMember"] = "abta-member";
    UspDialogs["ItaaMember"] = "itaa-member";
    UspDialogs["TrustpilotConfidence"] = "trustpilot-confidence";
})(UspDialogs || (UspDialogs = {}));
export var DiscountTypes;
(function (DiscountTypes) {
    DiscountTypes[DiscountTypes["mobileDiscount"] = 2] = "mobileDiscount";
})(DiscountTypes || (DiscountTypes = {}));
// export enum selectTabEnum {
//     'ROOMS' = 'rooms',
//     'REVIEWS' = 'reviews',
// }
export var productType;
(function (productType) {
    productType[productType["adult"] = 10] = "adult";
    productType[productType["child"] = 11] = "child";
})(productType || (productType = {}));
export var Funnel;
(function (Funnel) {
    Funnel[Funnel["HOTELHOLIDAY"] = 0] = "HOTELHOLIDAY";
    Funnel[Funnel["TRANSFER"] = 1] = "TRANSFER";
    Funnel[Funnel["ATTRACTION"] = 2] = "ATTRACTION";
})(Funnel || (Funnel = {}));
export var BookingPageType;
(function (BookingPageType) {
    BookingPageType[BookingPageType["PASSENGERS"] = 0] = "PASSENGERS";
    BookingPageType[BookingPageType["PAYMENT"] = 1] = "PAYMENT";
    BookingPageType[BookingPageType["TRANSFERBOOKING"] = 2] = "TRANSFERBOOKING";
})(BookingPageType || (BookingPageType = {}));
export var FlightType;
(function (FlightType) {
    FlightType["OUTBOUND"] = "outbound";
    FlightType["INBOUND"] = "inbound";
})(FlightType || (FlightType = {}));
export var AirportType;
(function (AirportType) {
    AirportType["DESTINATION_AIRPORT_CODE"] = "destinationAirportCode";
    AirportType["DESTINATION_AIRPORT_NAME"] = "destinationAirportName";
    AirportType["DEPARTURE_AIRPORT_CODE"] = "departureAirportCode";
    AirportType["DEPARTURE_AIRPORT_NAME"] = "departureAirportName";
})(AirportType || (AirportType = {}));
export var FlightTime;
(function (FlightTime) {
    FlightTime["OUTBOUND_DEPARTURE_FLIGHT_TIME_HOURS"] = "outboundDepartureFlightTimeHours";
    FlightTime["OUTBOUND_DEPARTURE_FLIGHT_TIME_MINUTES"] = "outboundDepartureFlightTimeMinutes";
    FlightTime["INBOUND_ARRIVAL_FLIGHT_TIME_MINUTES"] = "inboundArrivalFlightTimeMinutes";
    FlightTime["INBOUND_ARRIVAL_FLIGHT_TIME_HOURS"] = "inboundArrivalFlightTimeHours";
})(FlightTime || (FlightTime = {}));
export var FlightDate;
(function (FlightDate) {
    FlightDate["OUTBOUND_DEPARTURE_DATE"] = "outboundDepartureDate";
    FlightDate["INBOUND_ARRIVAL_DATE"] = "inboundArrivalDate";
})(FlightDate || (FlightDate = {}));
export var ProductType;
(function (ProductType) {
    ProductType[ProductType["SEAT"] = 461] = "SEAT";
})(ProductType || (ProductType = {}));
export var BookingExtraType;
(function (BookingExtraType) {
    BookingExtraType[BookingExtraType["BAG"] = 0] = "BAG";
    BookingExtraType[BookingExtraType["SEAT"] = 1] = "SEAT";
})(BookingExtraType || (BookingExtraType = {}));
export var ErrorTypeEnum;
(function (ErrorTypeEnum) {
    ErrorTypeEnum["Unexpected"] = "unexpected";
    ErrorTypeEnum["Prepayment"] = "prepayment";
    ErrorTypeEnum["Postpayment"] = "postpayment";
    ErrorTypeEnum["Validation"] = "validation";
    ErrorTypeEnum["Error"] = "";
})(ErrorTypeEnum || (ErrorTypeEnum = {}));
export var InsuranceRelationshipId;
(function (InsuranceRelationshipId) {
    InsuranceRelationshipId[InsuranceRelationshipId["INDIVIDUAL"] = 1] = "INDIVIDUAL";
    InsuranceRelationshipId[InsuranceRelationshipId["COUPLE"] = 2] = "COUPLE";
    InsuranceRelationshipId[InsuranceRelationshipId["SINGLE_PARENT_FAMILY"] = 3] = "SINGLE_PARENT_FAMILY";
    InsuranceRelationshipId[InsuranceRelationshipId["FAMILY"] = 4] = "FAMILY";
})(InsuranceRelationshipId || (InsuranceRelationshipId = {}));
